import * as React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, DatePicker, Input, Row, Tooltip, Form } from "antd";
import moment from "moment";
import { v4 as uuid } from "uuid";
import { ReactComponent as CancelButtonIcon } from "../../img/buttons_icons/cancelButton_icon.svg";
import { ReactComponent as SubmitButtonIcon } from "../../img/buttons_icons/submitButton_icon.svg";
import { ReactComponent as AddVersionIcon } from "../../img/versions_icons/addVersion_icon.svg";
import { ReactComponent as EditIcon } from "../../img/versions_icons/editVersion_icon.svg";
import {
  toDisplayFormat,
  displayFormat,
  toHttpFormatStartOfDay,
  toHttpFormat,
} from "../../lib/utils/formatDate";
import "../../styles/row.less";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { hasAccess } from "../RolesModule/hasAccess";
import { MENU_ACCOUNT_ACCOUNTINFO_WRITE } from "../../lib/const/permissions";
import ToggleableVersionsTable from "../ToggleableVersionsTable/ToggleableVersionsTable";
import versionsTableUtils from "../../lib/utils/versionsTableUtils";

export default function AccountAddressVersionsTable(props) {
  const { addressType, changeAddressVersion, fetchAddressVersions } = props;
  const {
    legalAddressesVersions,
    actualAddressesVersions,
    legalAddressesVersionsLoading,
    actualAddressesVersionsLoading,
    accountAddresses,
    accountAddressesLoading,
  } = useSelector((state) => state.accounts);
  const currentDate = moment();
  const [childTableData, setChildTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  
  const [form] = Form.useForm();

  const isChangingForbidden = versionsTableUtils.getIsTableChanging(childTableData);

  const handleSetInitialValue = (field) => {
    setTimeout(() => {
      form.setFieldsValue(field);
    }, 0);
  };

  const currentVersionsLoaded = () => {
    if (addressType === "legalAddress") {
      return checkIsLoaded(legalAddressesVersionsLoading);
    }
    return checkIsLoaded(actualAddressesVersionsLoading);
  };

  const neededVersions = () => {
    if (addressType === "legalAddress") {
      return legalAddressesVersions;
    }
    return actualAddressesVersions;
  };

  const columnsWidths = {
    ...versionsTableUtils.columnsWidths,
    addressType: 200,
    unstructuredAddress: "",
  };

  const [columns, setColumns] = useState([
    {
      title: "Тип адреса",
      dataIndex: "addressType",
      key: "addressType",
      width: columnsWidths.addressType,
      render: () => {
        if (addressType === "legalAddress") {
          return "Юридический адрес";
        }
        return "Почтовый адрес";
      },
    },
    {
      title: "Адрес",
      dataIndex: "unstructuredAddress",
      key: "unstructuredAddress",
      width: columnsWidths.unstructuredAddress,
    },
    {
      title: "Период действия",
      key: "period",
      dataIndex: "period",
      width: columnsWidths.period,
      render: (text, record) =>
        `${toDisplayFormat(record.fromDate)} - ${toDisplayFormat(record.toDate)}`,
    },
    {
      dataIndex: "actions",
      key: "actions",
      width: columnsWidths.actions,
      hidden: false,
    },
    {
      dataIndex: "buttons",
      key: "buttons",
      width: columnsWidths.buttons,
      hidden: false,
    },
  ]);

  const getChildColumns = () => [
    {
      title: "Тип адреса",
      dataIndex: "addressType",
      key: "addressType",
      width: columnsWidths.addressType,
      render: () => {
        if (addressType === "legalAddress") {
          return "Юридический адрес";
        }
        return "Почтовый адрес";
      },
    },
    {
      title: "Адрес",
      dataIndex: "unstructuredAddress",
      key: "unstructuredAddress",
      width: columnsWidths.unstructuredAddress,
      render(text, record) {
        if (record.isCreated) {
          handleSetInitialValue({ address: text });
          return (
            <Form.Item
              name="address"
              className="form-item-required__hidden-error__mb0"
              // initialValue={text}
            >
              <Input />
            </Form.Item>
          );
        }
        if (record.isEditing) {
          handleSetInitialValue({ address: text });
          return (
            <Form.Item
              name="address"
              className="form-item-required__hidden-error__mb0"
              // initialValue={text}
            >
              <Input />
            </Form.Item>
          );
        }
        return record.unstructuredAddress;
      },
    },
    {
      title: "Период действия",
      key: "period",
      dataIndex: "period",
      width: columnsWidths.period,
      render(text, record) {
        if (record.isCreated) {
          handleSetInitialValue({ fromDate: moment(record.fromDate).add(1, "day") });
          return (
            <div style={{ display: "flex" }}>
              <Form.Item name="fromDate" className="form-item-required__hidden-error__mb0">
                <DatePicker
                  format={displayFormat}
                  allowClear={false}
                  disabledDate={(current) =>
                    current <= moment(record.fromDate) || current > moment(record.toDate)
                  }
                  // defaultPickerValue={moment(record.fromDate).add(1, "day")}
                />
              </Form.Item>
              <Form.Item className="form-item-required__hidden-error__mb0">
                -{toDisplayFormat(record.toDate)}
              </Form.Item>
            </div>
          );
        }
        return `${toDisplayFormat(moment(record.fromDate))} - ${toDisplayFormat(
          moment(record.toDate)
        )}`;
      },
    },
    {
      title: "",
      key: "actions",
      dataIndex: "actions",
      width: columnsWidths.actions,
      hidden: false,
      render: (value, record) => {
        if (hasAccess(MENU_ACCOUNT_ACCOUNTINFO_WRITE)) {
          if (record.isCreated || record.isEditing) {
            return (
              <Row>
                <Tooltip title="Подтвердить">
                  <Button
                    className="button-icon"
                    icon={<SubmitButtonIcon />}
                    type="text"
                    htmlType="button"
                    onClick={(event) => {
                      event.stopPropagation();
                      form.submit();
                    }}
                  />
                </Tooltip>
                <Tooltip title="Отменить">
                  <Button
                    className="button-icon"
                    icon={<CancelButtonIcon />}
                    type="text"
                    htmlType="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (record.isCreated) {
                        setChildTableData((prevState) => prevState.filter((obj) => !obj.isCreated));
                      }
                      if (record.isEditing) {
                        setChildTableData((prevState) =>
                          prevState.map((item) => {
                            if (item.isEditing) {
                              return { ...item, isEditing: false };
                            }
                            return item;
                          })
                        );
                      }
                      form.resetFields();
                    }}
                  />
                </Tooltip>
              </Row>
            );
          }
          if (!record.isPastVersion) {
            return (
              <Row>
                <Tooltip title="Добавить версию">
                  <Button
                    className="button-icon"
                    icon={<AddVersionIcon />}
                    type="text"
                    htmlType="button"
                    disabled={isChangingForbidden}
                    onClick={(e) => {
                      e.stopPropagation();
                      setChildTableData((prevState) =>
                        [
                          {
                            ...record,
                            key: uuid(),
                            fromDate: moment(record.fromDate).add(1, "seconds"),
                            isCreated: true,
                            isCurrentVersion: false,
                            isPastVersion: false,
                            isLatestVersion: false,
                          },
                          ...prevState,
                        ].sort((a, b) => (moment(a.fromDate).isBefore(moment(b.fromDate)) ? 1 : -1))
                      );
                    }}
                  />
                </Tooltip>
                <Tooltip title="Редактировать версию">
                  <Button
                    className="button-icon"
                    icon={<EditIcon />}
                    type="text"
                    htmlType="button"
                    disabled={isChangingForbidden}
                    onClick={(e) => {
                      e.stopPropagation();
                      setChildTableData((prevState) =>
                        prevState.map((item) => {
                          if (item.key === record.key) return { ...item, isEditing: true };
                          return item;
                        })
                      );
                    }}
                  />
                </Tooltip>
              </Row>
            );
          }
        }
        return null;
      },
    },
    {
      title: "",
      dataIndex: "buttons",
      key: "buttons",
      width: columnsWidths.buttons,
      hidden: false,
    },
  ];

  const [childColumns, setChildColumns] = useState(getChildColumns());

  useEffect(() => {
    setChildColumns(getChildColumns());
  }, [isChangingForbidden]);

  useEffect(() => {
    if (checkIsLoaded(accountAddressesLoading)) {
      setTableData([
        {
          key: accountAddresses[addressType]?.id,
          id: accountAddresses[addressType]?.id,
          unstructuredAddress: accountAddresses[addressType]?.unstructuredAddress,
          fromDate: accountAddresses[addressType]?.fromDate,
          toDate: accountAddresses[addressType]?.toDate,
        },
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountAddressesLoading]);

  useEffect(() => {
    const versions = neededVersions();
    if (currentVersionsLoaded()) {
      setChildTableData(
        versions[0]
          .map((version, i) => ({
            ...version,
            key: i,
            id: version.id,
            unstructuredAddress: version.unstructuredAddress,
            fromDate: version.fromDate,
            toDate: version.toDate,
            isCurrentVersion:
              moment(currentDate).isSameOrAfter(version.fromDate) &&
              moment(currentDate).isBefore(version.toDate),
            isPastVersion: moment(version?.toDate).isBefore(currentDate),
            isLatestVersion: versions[0].length === i + 1,
            isClosing: false,
            isCreated: false,
            isEditing: false,
          }))
          .sort((a, b) => (moment(a.fromDate).isBefore(moment(b.fromDate)) ? 1 : -1))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [legalAddressesVersionsLoading, actualAddressesVersionsLoading]);

  const handleCreateVersion = () => {
    const values = form.getFieldsValue();
    const version = childTableData.find((item) => item?.isCreated || item?.isEditing);
    const isForceUpdate = !!version?.isEditing;
    const versionDate = isForceUpdate ? version.fromDate : toHttpFormatStartOfDay(values.fromDate);

    [
      "key",
      "isClosing",
      "isCreated",
      "isCurrentVersion",
      "isLatestVersion",
      "isPastVersion",
      "fromDate",
      "toDate",
      "isEditing",
    ].forEach((i) => delete version[i]);

    changeAddressVersion({
      addressId: version.id,
      fromDate: versionDate,
      addressObj: {
        ...version,
        unstructuredAddress: values.address,
      },
      addressType,
      force: isForceUpdate,
    });
  };

  return (
    <Form onFinish={handleCreateVersion} form={form}>
      <ToggleableVersionsTable
        tableName="organization-address-table"
        columns={columns}
        setColumns={setColumns}
        childTableColumns={childColumns}
        setChildTableColumns={setChildColumns}
        tableData={tableData}
        childTableData={childTableData}
        isChildTableLoading={checkIsLoading(
          legalAddressesVersionsLoading,
          actualAddressesVersionsLoading
        )}
        tableClassName="organization-address-table"
        isPageable={false}
        isToggleableColumns={false}
        onOpenVersionsCallback={(record) => {
          fetchAddressVersions({ addressId: record.id, addressType });
        }}
      />
    </Form>
  );
}
